module.exports = __webpack_public_path__ + "static/img/bg_mo.26e6595.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/images/bg_mo.png
// module id = rfug
// module chunks = 0